import { UploadService } from './upload.service';
import { AuthService } from './auth.service';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SimpleChatService {
  constructor(
    private readonly authService: AuthService,
    private readonly apiService: ApiService
  ) {}

  /**
   * Get history messages for that room
   * @param chatId
   */
  getHistoryGroupMessages(chatId): Observable<any> {
    const subject = new Subject<any>();

    this.apiService.httpGet('/topic/' + chatId + '/messages').subscribe(
      (data: any) => {
        // Reverse array to get at the end the most recent messages
        if (data) data.reverse();

        subject.next(data);
      },
      (err: any) => {
        subject.error(err);
      }
    );

    return subject.asObservable();
  }

  /**
   * Get history messages of private conversation
   * @param chatId
   */
  getHistoryPrivateMessages(usernameTo: string): Observable<any> {
    const subject = new Subject<any>();

    const authUser = this.authService.getAuthUser();

    this.apiService.httpGet('/chat/' + authUser.username + '/' + usernameTo + '/messages').subscribe(
      (data: any) => {
        // Reverse array to get at the end the most recent messages
        if (data) data.reverse();

        subject.next(data);
      },
      (err: any) => {
        subject.error(err);
      }
    );

    return subject.asObservable();
  }
}
